import React from "react";
import { useSelector } from "react-redux";
import { brandingCustomCssSelector } from "Utils/selectors";

interface BrandingCustomCssProps {

}
export const BrandingCustomCss: React.FC<BrandingCustomCssProps> = function () {
   const brandingCustomCss = useSelector(brandingCustomCssSelector);

   return brandingCustomCss
      ? <style>{brandingCustomCss}</style>
      : null;
}